/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP17_ANSWERS = [
    'Harry is reading a book about health. He suddenly screams to his mom.',
    'Stephanie rushes to Harry. Harry says he is sweating and has a headache.',
    'Harry thinks he needs to go to the hospital!',
    'At the hospital, Stephanie says to Harry, “Calm down. You’re gonna be fine.”',
    'The doctor comes into the room.',
    'Dr. Smith wants to run some tests. First, he checks Harry’s temperature.',
    'Then, Dr. Smith asks Harry to open his mouth and stick out his tongue.',
    'Next, Dr. Smith checks Harry’s blood pressure.',
    'Finally, Dr. Smith says Harry’s problem is ASNP; All Study No Play.',
    'Harry doesn’t need medicine. He just needs to play as much as he reads.',
];

// export const HHT2_EP17_ANSWER_SOUNDS = [
//     '/HHT2_AB EP17_dyr01.mp3',
//     '/HHT2_AB EP17_dyr02.mp3',
//     '/HHT2_AB EP17_dyr03.mp3',
//     '/HHT2_AB EP17_dyr04.mp3',
//     '/HHT2_AB EP17_dyr05.mp3',
//     '/HHT2_AB EP17_dyr06.mp3',
//     '/HHT2_AB EP17_dyr07.mp3',
//     '/HHT2_AB EP17_dyr08.mp3',
//     '/HHT2_AB EP17_dyr09.mp3',
//     '/HHT2_AB EP17_dyr10.mp3',
// ];

export const HHT2_EP17_ANSWER_SOUNDS = [
    '/98fdf3228004d98bd50d525ff32d9623.mp3',
    '/c0940e48514cb42611b41af645a92906.mp3',
    '/a88a55e337cd1585d5f414701feaee92.mp3',
    '/7d5ef90a3f61bc46b39d03c6eace6b79.mp3',
    '/d632fecaa7073cfdaca3462e1e2cdc20.mp3',
    '/24f58c10ab8c1e10e3402dbd39152efb.mp3',
    '/a29d07c7fe6d28164164010713321e06.mp3',
    '/4f7260af376d7cf9ec2376012748f8c4.mp3',
    '/693fdd749031eedddfa6cc5ba458eda8.mp3',
    '/c4dd962fa95f08086f23f2afeaba260d.mp3',
];

export const HHT2_EP17_QUIZ_ITEMS = [{
    'A': HHT2_EP17_ANSWERS[1],
    'B': HHT2_EP17_ANSWERS[8],
    'SoundIndexA': 1,
    'SoundIndexB': 8,
    'answer': HHT2_EP17_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP17_ANSWERS[4],
        'B': HHT2_EP17_ANSWERS[0],
        'SoundIndexA': 4,
        'SoundIndexB': 0,
        'answer': HHT2_EP17_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP17_ANSWERS[2],
        'B': HHT2_EP17_ANSWERS[7],
        'SoundIndexA': 2,
        'SoundIndexB': 7,
        'answer': HHT2_EP17_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP17_ANSWERS[9],
        'B': HHT2_EP17_ANSWERS[3],
        'SoundIndexA': 9,
        'SoundIndexB': 3,
        'answer': HHT2_EP17_ANSWERS[9],
        'sound': [9],
        'exception': false,
    },
]
